export const VDS_MANAGEMENT = "#VdsManagement";

export const USERS = "#Users";
export const VIEW_USERS = "#ViewUsers";
export const VIEW_END_USERS = "#ViewEndUser";
export const VIEW_CONSULTANT = "#ViewConsultant";
export const VIEW_EG_ADMIN = "#ViewEGAdmin";
export const MANAGE_USERS = "#ManageUsers";
export const MANAGE_END_USERS = "#ManageEndUser";
export const MANAGE_CONSULTANT = "#ManageConsultant";
export const MANAGE_EG_ADMIN = "#ManageEGAdmin";

export const BRANCHES = "#Branches";
export const VIEW_BRANCHES = "#ViewBranches";
export const MANAGE_BRANCHES = "#ManageBranches";

export const PRODUCTS = "#Products";

export const BILLING = "#Billing";

export const ACTIVITY = "#Activity";

//Branch Detail
export const MANAGE_BRANCH_PAYMENT = "#ManagePayments";
export const VIEW_BRANCH_PAYMENT = "#ViewPayments";

export const MANAGE_BRANCH_DOCUMENT = "#ManageDocuments";
export const VIEW_BRANCH_DOCUMENT = "#ViewDocuments";

export const MANAGE_BRANCH_TEAM = "#ManageTeams";
export const VIEW_BRANCH_TEAM = "#ViewTeams";

